export default __webpack_public_path__ + "static/media/final-interest.40c48f7c.png";